export default __webpack_public_path__ + "static/media/Path3525.5a2b90bb.svg";